import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { initNativePlugins } from './capacitorInit';
import { ErrorBoundary } from './components/ErrorBoundary';

// Initialize Capacitor plugins before first render (no-op on web)
initNativePlugins();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
